/* catalog-canonical-view-redirect-20260710 */
(function () {
  var routes = {
    "/products/maruishi-catalog": "catalog-main-fabric-routes-20260710",
    "/products/wakeari-fabric": "wakeari-fabric-v2"
  };
  var location = window.location;
  if (!location) return;
  var targetView = routes[location.pathname];
  if (!targetView) return;

  var url = new URL(location.href);
  if (url.searchParams.get("view") === targetView) return;
  url.searchParams.set("view", targetView);
  location.replace(url.toString());
})();

/* product-card-swatch-hotfix-20260611 */
(function () {
  var marker = "product-card-swatch-hotfix-20260611";
  if (document.getElementById(marker)) return;
  var style = document.createElement("style");
  style.id = marker;
  style.textContent = ":root{--product-card-swatch-hotfix-20260611:1}.product-card__image-container{display:none}.product-card__color-swatches{display:flex;align-items:center;justify-content:flex-start;gap:4px;width:100%;max-width:100%;min-width:0;min-height:30px;margin-top:2px;overflow:hidden}.product-card__color-swatches:empty{display:none}.product-card__color-swatch-viewport{flex:1 1 auto;min-width:0;max-width:100%;overflow:hidden}.product-card__color-swatch-list{display:flex;align-items:center;justify-content:flex-start;gap:8px;flex-wrap:nowrap;max-width:100%;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x proximity;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:4px 2px 6px;margin:-4px -2px -6px}.product-card__color-swatch-list::-webkit-scrollbar{display:none}.product-card__color-swatch{flex:0 0 28px;display:grid;place-items:center;width:28px;height:28px;padding:2px;border:1px solid #D2C9C0;border-radius:5px;background:#fff center/cover no-repeat;box-shadow:0 4px 10px rgba(63,58,57,.12);overflow:hidden;cursor:pointer;scroll-snap-align:start;transition:border-color .16s ease,box-shadow .16s ease,transform .16s ease}.product-card__color-swatch:hover,.product-card__color-swatch.is-selected,.product-card__color-swatch[aria-current=true]{border-color:#3F3A39;box-shadow:0 6px 14px rgba(63,58,57,.18);transform:translateY(-1px)}.product-card__color-swatch img{display:block;width:100%;height:100%;border-radius:3px;object-fit:cover}.product-card__color-swatch-next{display:none;flex:0 0 auto;align-items:center;justify-content:center;width:24px;height:28px;padding:0;border:0;border-radius:999px;background:transparent;color:var(--base-bk,#3F3A39);cursor:pointer}.product-card__color-swatches.is-scrollable .product-card__color-swatch-next{display:inline-flex}.product-card__color-swatch-next:hover{color:#111}.product-card__color-swatch-next svg{width:14px;height:auto}.product-card__color-count{letter-spacing:0;white-space:nowrap}";
  (document.head || document.documentElement).appendChild(style);
})();

/* school-invoice-copy-fix-20260616 */
(function () {
  function updateSchoolInvoiceCopy() {
    if (window.location.pathname !== '/pages/school-public-invoice-payment') return;

    var page = document.querySelector('[data-school-invoice-payment-page]');
    if (!page) return;

    var headings = page.querySelectorAll('.sip-section-head');
    headings.forEach(function (heading) {
      var title = heading.querySelector('.sip-title');
      if (!title || title.textContent.trim() !== '学校で使いやすい入口') return;

      var kicker = heading.querySelector('.sip-kicker');
      var lead = heading.querySelector('p:not(.sip-kicker)');
      if (kicker) kicker.textContent = '商品選びの参考に';
      title.textContent = '学校教材・製作販売で使いやすい生地';
      if (lead) {
        lead.textContent = 'お見積りをご希望の場合は、候補の商品ページURLと必要数量をお知らせください。まだ商品が決まっていない場合は、作るものや用途から一緒に確認します。';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSchoolInvoiceCopy);
  } else {
    updateSchoolInvoiceCopy();
  }
})();

// バリアント選択時にギャラリー位置へスクロール＋サムネイルストリップを追従
// variant-pickerのchangeイベントでページスクロール、
// MutationObserverでセクション再レンダリング後のサムネイルスクロールを処理

// ページスクロール: variant-pickerのchangeをcaptureフェーズで検知
document.addEventListener('change', (e) => {
  if (!e.target.closest('variant-picker')) return;
  const section = document.querySelector('product-gallery')?.closest('.shopify-section');
  if (!section) return;
  const sectionTop = section.offsetTop;
  const headerH = document.querySelector('.shopify-section-group-header-group')?.offsetHeight || 0;
  window.scrollTo({ top: Math.max(0, sectionTop - headerH), behavior: 'smooth' });
}, true);

// セクション再レンダリング後の処理:
// 1. サムネイルスクロール
// 2. ギャラリー画像の並べ替え（選択バリアントの関連画像を先頭に）
(function () {
  let renderTimer = null;

  const onSectionRerendered = () => {
    // サムネイルスクロール
    const nav = document.querySelector('product-gallery-navigation');
    if (nav && nav.scrollWidth > nav.clientWidth) {
      const current = nav.querySelector('[aria-current="true"]');
      if (current) {
        const targetLeft = current.offsetLeft - nav.clientWidth / 2 + current.clientWidth / 2;
        nav.scrollLeft = Math.max(0, Math.min(targetLeft, nav.scrollWidth - nav.clientWidth));
      }
    }

    // ギャラリー並べ替え: .is-initialの画像を基準に実行
    const gallery = document.querySelector('product-gallery');
    if (gallery) {
      const initialMedia = gallery.querySelector('.product-gallery__media.is-initial');
      if (initialMedia && initialMedia.dataset.mediaId) {
        window.__reorderGallery(gallery, initialMedia.dataset.mediaId);
      }
    }
  };

  const observer = new MutationObserver(() => {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(onSectionRerendered, 600);
  });

  const startObserving = () => {
    const gallerySection = document.querySelector('product-gallery')?.closest('.shopify-section');
    if (gallerySection) {
      observer.observe(gallerySection, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

// バリアント選択時にギャラリー画像を並べ替え:
// 完全一致(同バリアントのアップ写真) → 共通画像 → 同色別サイズ → 他色
(function() {
  // altからオプションタグをパース: {カラー: "#103 みずいろ", 柄の大きさ: "1.5mm"}
  // 形式例: "商品名#柄の大きさ_1.5mm#カラー_#102 サーモンピンク"
  function parseTags(alt) {
    if (!alt || alt.indexOf('#') === -1) return {};
    var tags = {};
    // #の後ろがオプション名_値のパターンを探す
    // 色番号に#が含まれるため、既知のオプション名で分割する
    var knownOptions = ['カラー', '色', 'Color', '柄の大きさ', 'サイズ', 'Size'];
    var remaining = alt;
    // 最初の#より前を除去
    var firstHash = remaining.indexOf('#');
    if (firstHash === -1) return {};
    remaining = remaining.substring(firstHash);

    for (var i = 0; i < knownOptions.length; i++) {
      var prefix = '#' + knownOptions[i] + '_';
      var idx = remaining.indexOf(prefix);
      if (idx === -1) continue;
      var valueStart = idx + prefix.length;
      // 値の終端: 次の既知オプションタグの開始位置
      var valueEnd = remaining.length;
      for (var j = 0; j < knownOptions.length; j++) {
        if (j === i) continue;
        var nextPrefix = '#' + knownOptions[j] + '_';
        var nextIdx = remaining.indexOf(nextPrefix, valueStart);
        if (nextIdx !== -1 && nextIdx < valueEnd) valueEnd = nextIdx;
      }
      tags[knownOptions[i].toLowerCase()] = remaining.substring(valueStart, valueEnd).trim().toLowerCase();
    }
    return tags;
  }

  function getColorValue(tags) {
    return tags['カラー'] || tags['色'] || tags['color'] || null;
  }

  function isShared(alt) {
    if (!alt || alt.indexOf('#') === -1) return true;
    var tags = parseTags(alt);
    var color = getColorValue(tags);
    return color === null || color === '共通';
  }

  window.__reorderGallery = reorderGallery;

  function reorderGallery(gallery, featuredMediaId) {
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var mediaEls = Array.from(carousel.querySelectorAll('.product-gallery__media'));
    var featuredEl = mediaEls.find(function(el) { return el.dataset.mediaId === featuredMediaId; });
    if (!featuredEl) return;

    var featuredImg = featuredEl.querySelector('img');
    var featuredTags = parseTags(featuredImg ? featuredImg.alt : '');
    var selectedColor = getColorValue(featuredTags);
    if (!selectedColor) return;

    // 画像を分類
    var featured = [], exact = [], shared = [], sameColor = [], others = [];
    mediaEls.forEach(function(el) {
      if (el.dataset.mediaId === featuredMediaId) {
        featured.push(el);
        return;
      }
      var img = el.querySelector('img');
      var alt = img ? img.alt : '';
      if (isShared(alt)) {
        shared.push(el);
        return;
      }
      var tags = parseTags(alt);
      var color = getColorValue(tags);
      if (color !== selectedColor) {
        others.push(el);
        return;
      }
      // 全タグ一致（同バリアントのアップ写真）か判定
      var allMatch = true;
      for (var key in featuredTags) {
        if (featuredTags[key] !== tags[key]) { allMatch = false; break; }
      }
      if (allMatch) {
        exact.push(el);
      } else {
        sameColor.push(el);
      }
    });

    // DOM並べ替え: メイン → 完全一致 → 共通 → 同色別サイズ → 他色
    var newOrder = featured.concat(exact, shared, sameColor, others);
    newOrder.forEach(function(el) { carousel.appendChild(el); });

    // サムネイルも同じ順序に
    var thumbNav = gallery.querySelector('product-gallery-navigation');
    if (thumbNav) {
      var thumbMap = {};
      thumbNav.querySelectorAll('.product-gallery__thumbnail').forEach(function(t) {
        thumbMap[t.dataset.mediaId] = t;
      });
      newOrder.forEach(function(el) {
        var t = thumbMap[el.dataset.mediaId];
        if (t) thumbNav.appendChild(t);
      });
    }
  }

  function init() {
    // 初期表示: 選択中バリアントで並べ替え
    var gallery = document.querySelector('product-gallery');
    if (!gallery) return;
    var initialMedia = gallery.querySelector('.product-gallery__media.is-initial');
    if (initialMedia && initialMedia.dataset.mediaId) {
      reorderGallery(gallery, initialMedia.dataset.mediaId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-selector[data-multiplier]').forEach((selector) => {
    const multiplier = parseInt(selector.dataset.multiplier || '1', 10);
    const input = selector.querySelector('input.quantity-selector__input');
    const display = selector.querySelector('.quantity-display');

    if (!input || !display) return;

    const updateDisplay = () => {
      const value = parseInt(input.value || '1', 10);
      display.textContent = value * multiplier;
    };

    input.addEventListener('input', updateDisplay);
    input.addEventListener('change', updateDisplay);
    updateDisplay(); // 初期表示反映
  });
});

// Shopifyのフルページキャッシュが古い記事HTMLを返した時のカテゴリ表示補正。
// Liquid側では固定カテゴリを表示するが、古いHTMLでは article.tags.first が残ることがある。
(function() {
  var categoryHandles = {
    'お知らせ': 'お知らせ',
    '生地の選び方': '生地の選び方',
    '作り方・型紙': '作り方-型紙',
    '作品例・布合わせ': '作品例-布合わせ',
    '入園入学': '入園入学',
    '子ども服・ベビー': '子ども服-ベビー',
    '大人服・エプロン': '大人服-エプロン',
    'バッグ・小物': 'バッグ-小物',
    '犬服・ドール服': '犬服-ドール服',
    'ミシン・道具': 'ミシン-道具'
  };
  var fixedCategories = Object.keys(categoryHandles);

  function text(el) {
    return (el && el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function taggedBase(href) {
    var match = String(href || '').match(/^(.*\/blogs\/[^/]+)\/tagged\//);
    return match ? match[1] : '/blogs/journal';
  }

  function categoryUrl(base, category) {
    return base + '/tagged/' + categoryHandles[category];
  }

  function fixCachedArticleCategory() {
    var currentLink = document.querySelector('.article-header__category');
    if (!currentLink) return;

    var currentCategory = text(currentLink);
    if (fixedCategories.indexOf(currentCategory) !== -1) return;

    var tagTexts = Array.from(document.querySelectorAll('.article-header__tag, .article-tags-section__tag')).map(text);
    var desiredCategory = fixedCategories.find(function(category) {
      return tagTexts.indexOf(category) !== -1;
    });
    if (!desiredCategory) return;

    var base = taggedBase(currentLink.getAttribute('href'));
    currentLink.textContent = desiredCategory;
    currentLink.setAttribute('href', categoryUrl(base, desiredCategory));

    document.querySelectorAll('.article-breadcrumb a[href*="/tagged/"]').forEach(function(link) {
      if (fixedCategories.indexOf(text(link)) === -1 || text(link) === currentCategory) {
        link.textContent = desiredCategory;
        link.setAttribute('href', categoryUrl(base, desiredCategory));
      }
    });

    document.querySelectorAll('.article-header__tag').forEach(function(link) {
      if (text(link) === desiredCategory) link.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCachedArticleCategory);
  } else {
    fixCachedArticleCategory();
  }
})();

/* dogwear-video-mp4-fix-20260612 */
(function () {
  var replacements = [
    {
      oldUrl: 'https://cdn.shopify.com/videos/c/o/v/b3c32eb54dd1482b9f4fec79ab5e589a.mov',
      newUrl: 'https://cdn.shopify.com/videos/c/vp/5cc002efc49c48a092615be294a440d5/5cc002efc49c48a092615be294a440d5.HD-720p-4.5Mbps-86382851.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0944/6821/0981/files/dogwear-13-001-running-video-poster-20260612.jpg?v=1781269347'
    },
    {
      oldUrl: 'https://cdn.shopify.com/videos/c/o/v/edf0a0adc91e4985b9cee38d674e4111.mov',
      newUrl: 'https://cdn.shopify.com/videos/c/vp/aa23d307afd04b2298ea81fc553bb11f/aa23d307afd04b2298ea81fc553bb11f.HD-720p-3.0Mbps-86382904.mp4',
      poster: 'https://cdn.shopify.com/s/files/1/0944/6821/0981/files/dogwear-13-002-7000-video-poster-20260612.jpg?v=1781269371'
    }
  ];

  function replaceLinkTargets(root, oldUrl, newUrl) {
    root.querySelectorAll('a[href="' + oldUrl + '"]').forEach(function (link) {
      link.setAttribute('href', newUrl);
    });
  }

  function fixDogwearVideos() {
    replacements.forEach(function (item) {
      document.querySelectorAll('video source[src="' + item.oldUrl + '"]').forEach(function (source) {
        var video = source.closest('video');
        source.setAttribute('src', item.newUrl);
        source.setAttribute('type', 'video/mp4');
        if (video) {
          video.setAttribute('poster', item.poster);
          replaceLinkTargets(video, item.oldUrl, item.newUrl);
          video.load();
        }
      });
      replaceLinkTargets(document, item.oldUrl, item.newUrl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixDogwearVideos);
  } else {
    fixDogwearVideos();
  }
})();

/* restock-alert-20260708 */
(function () {
  if (window.__maruishiRestockAlertInit) return;
  window.__maruishiRestockAlertInit = true;

  var KLAVIYO_REVISION = '2026-04-15';

  function getAlert(target) {
    return target && target.closest ? target.closest('[data-restock-alert]') : null;
  }

  function getFields(root) {
    return root ? root.querySelector('[data-restock-fields]') : null;
  }

  function getEmailInput(root) {
    return root ? root.querySelector('[data-restock-email]') : null;
  }

  function getSubmitButton(root) {
    return root ? root.querySelector('[data-restock-submit]') : null;
  }

  function getMessage(root) {
    return root ? root.querySelector('[data-restock-message]') : null;
  }

  function setMessage(root, text, state) {
    var message = getMessage(root);
    if (!message) return;
    message.textContent = text || '';
    message.classList.remove('is-success', 'is-error');
    if (state) message.classList.add('is-' + state);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function openAlert(root) {
    var fields = getFields(root);
    var input = getEmailInput(root);
    var trigger = root ? root.querySelector('[data-restock-open]') : null;
    if (!root || !fields) return;

    fields.hidden = false;
    root.classList.add('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    setMessage(root, '', '');

    if (input) {
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }
      window.setTimeout(function () {
        try {
          input.focus({ preventScroll: true });
        } catch (error) {
          input.focus();
        }
      }, 80);
    }
  }

  function setSubmitting(root, submitting) {
    var submit = getSubmitButton(root);
    if (!submit) return;
    submit.disabled = submitting;
    submit.textContent = submitting ? '登録しています...' : '通知を登録する';
  }

  function buildPayload(email, variantId) {
    return {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: '$shopify:::$default:::' + variantId
            }
          }
        }
      }
    };
  }

  function parseError(responseText) {
    try {
      var json = JSON.parse(responseText);
      var first = json && json.errors && json.errors[0];
      return first && (first.detail || first.title);
    } catch (error) {
      return '';
    }
    return '';
  }

  function submitAlert(root) {
    var companyId = root && root.dataset ? root.dataset.companyId : '';
    var variantId = root && root.dataset ? root.dataset.variantId : '';
    var input = getEmailInput(root);
    var email = input ? input.value.trim() : '';

    if (!isValidEmail(email)) {
      setMessage(root, 'メールアドレスを入力してください。', 'error');
      if (input) input.focus();
      return;
    }

    if (!companyId || !variantId) {
      setMessage(root, '登録できませんでした。時間をおいてもう一度お試しください。', 'error');
      return;
    }

    setSubmitting(root, true);
    setMessage(root, '', '');

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: KLAVIYO_REVISION
      },
      body: JSON.stringify(buildPayload(email, variantId))
    })
      .then(function (response) {
        if (response.ok) return '';
        return response.text().then(function (text) {
          throw new Error(parseError(text) || 'request failed');
        });
      })
      .then(function () {
        var submit = getSubmitButton(root);
        root.classList.add('is-complete');
        if (submit) {
          submit.disabled = true;
          submit.textContent = '登録済み';
        }
        setMessage(root, '登録しました。再入荷したらメールでお知らせします。', 'success');
      })
      .catch(function () {
        setMessage(root, '登録できませんでした。時間をおいてもう一度お試しください。', 'error');
      })
      .finally(function () {
        if (!root.classList.contains('is-complete')) setSubmitting(root, false);
      });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest ? event.target.closest('[data-restock-open]') : null;
    if (openButton) {
      event.preventDefault();
      openAlert(getAlert(openButton));
      return;
    }

    var submitButton = event.target.closest ? event.target.closest('[data-restock-submit]') : null;
    if (submitButton) {
      event.preventDefault();
      submitAlert(getAlert(submitButton));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (!event.target.matches || !event.target.matches('[data-restock-email]')) return;
    event.preventDefault();
    submitAlert(getAlert(event.target));
  });
})();
// cart-pattern-popup-disabled-20260710: remove cart pattern popup markup from stale Shopify full-page cache.
(function () {
  function removeRevertedCartPatternPopup() {
    try {
      sessionStorage.setItem('katagami_popup_dismissed', '1');
    } catch (_) {}

    if (window.location.pathname.replace(/\/+$/, '') !== '/cart') return;

    document.querySelectorAll('.katagami-popup').forEach(function (popup) {
      popup.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeRevertedCartPatternPopup, { once: true });
  } else {
    removeRevertedCartPatternPopup();
  }

  window.addEventListener('pageshow', removeRevertedCartPatternPopup);
})();
